var _excluded = ["disabled", "fieldSize", "id", "intensity", "required", "text"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled, { css } from 'styled-components';
import { Intensities, Sizes } from "../../../constants.js";
import { getSharedFieldLabelAndLegendStyles } from "../../../utils/index.js";
import FieldRequiredAbbr from "../FieldRequiredAbbr/FieldRequiredAbbr.js";
var StyledLegend = styled.legend.withConfig({
  componentId: "CL__sc-1uhzrd8-0"
})(["display:block;cursor:", ";", ""], _ref => {
  var {
    $disabled
  } = _ref;
  return $disabled ? 'default' : 'pointer';
}, _ref2 => {
  var {
    $disabled,
    $size,
    $intensity
  } = _ref2;
  if ($size === Sizes.LARGE) return css(["", ";margin-bottom:var(--spacing-3);"], getSharedFieldLabelAndLegendStyles({
    bodyTextSize: Sizes.MEDIUM,
    disabled: $disabled,
    intensity: $intensity
  }));
  if ($size === Sizes.SMALL) return css(["", ";margin-bottom:var(--spacing-1);"], getSharedFieldLabelAndLegendStyles({
    bodyTextSize: Sizes.X_SMALL,
    disabled: $disabled,
    intensity: $intensity
  }));
  return css(["", ";margin-bottom:var(--spacing-1);"], getSharedFieldLabelAndLegendStyles({
    bodyTextSize: Sizes.SMALL,
    disabled: $disabled,
    intensity: $intensity
  }));
});
var FieldLegend = _ref3 => {
  var {
      disabled = false,
      fieldSize = Sizes.MEDIUM,
      id,
      intensity = Intensities.DEFAULT,
      required = false,
      text
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(StyledLegend, _extends({
    $disabled: disabled,
    $intensity: intensity,
    $size: fieldSize,
    id: id
  }, rest), /*#__PURE__*/React.createElement("span", null, text), !disabled && required && /*#__PURE__*/React.createElement(FieldRequiredAbbr, {
    fieldSize: fieldSize
  }));
};
export default FieldLegend;